import { PermissionCode, ResourceCode } from '@/const/code';

export default [
  {
    path: '/syllabus',
    name: 'syllabus',
    component: () => import('@/views/main/syllabus/Syllabus.vue'),
    meta: {
      pageTitle: 'Đề cương học phần',
      breadcrumb: [
        {
          text: 'Quản lý đào tạo',
          active: false,
        },
        {
          text: 'Đề cương học phần',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.SYLLABUS,
    },
  },
  {
    path: '/course-completed',
    name: 'courseCompleted',
    component: () => import('@/views/course-completed/CourseCompleted.vue'),
    meta: {
      pageTitle: 'Xét hoàn thành khóa học',
      breadcrumb: [
        {
          text: 'Quản lý đào tạo',
          active: false,
        },
        {
          text: 'Xét hoàn thành khóa học',
          active: true,
        },
      ],
      action: PermissionCode.READ,
      resource: ResourceCode.COURSE_COMPLETED,
    },
  },
]
